<template>
    <div class="col-12">
        <div class="row">
            <b-overlay :show="loading" class="content">
                <div class="mb-3 text-center">
                    <hr />
                    <strong>{{ $t("view.club.menus.shop") }}</strong>
                    <hr />
                </div>
                <div class="col-12 col-md-4 float-right mb-3 shop"
                     v-for="(shop, index) in shops">
                    <b-card>
                        <div class="img" v-if="shop.imagePath"
                             v-bind:style="{'background-image':'url(' + rootImagePath + shop.imagePath + ')'}"></div>

                        <div class="img" v-else
                             v-bind:style="{'background-image':'url('+ require('../../assets/image/NoImage.jpg') +')'}"></div>

                        <b-card-body>
                            <b-card-title>{{ shop.name }}</b-card-title>
                            <b-card-sub-title class="mt-2">{{ shop.shopCategoryName }}</b-card-sub-title>
                        </b-card-body>

						<b-list-group flush>
							<b-list-group-item>
								<router-link class="item" :to="{name: 'shop',params: {id: shop.shopId,name: shop.name.replace(/ /gi, '-')}}">
									مشاهده فروشگاه
								</router-link>
							</b-list-group-item>
							<b-list-group-item>
								<router-link class="item" :to="{name: 'club',params: { action: 'shopTransactions' , id: shop.shopId}}">
									مشاهده تراکنش های خرید
								</router-link>
							</b-list-group-item>
							<b-list-group-item>
								<router-link class="item" :to="{name: 'club',params: { action: 'shopTransactionsGroup' , id: shop.shopId}}">
									مشاهده تراکنش های خرید به تفکیک ماه
								</router-link>
							</b-list-group-item>
							<b-list-group-item>
								<router-link class="item" :to="{name: 'club',params: { action: 'shopSplitAnalytics' , id: shop.shopId}}">
									مشاهده تحلیل اقساط
								</router-link>
							</b-list-group-item>
							<b-list-group-item>
								<router-link class="item" :to="{name: 'club',params: { action: 'shopCustomerPayments' , id: shop.shopId}}">
									مشاهده واریزی های سازمان
								</router-link>
							</b-list-group-item>
							<b-list-group-item>
								<router-link class="item" :to="{name: 'club',params: { action: 'shopProductList' , id: shop.shopId}}">
									مشاهده محصولات
								</router-link>
							</b-list-group-item>
							<b-list-group-item>
								<a @click="initCreateProduct(shop)">ثبت محصولات</a>
							</b-list-group-item>
							<b-list-group-item class="text-muted">گزارش فروش آنلاین (به زودی)</b-list-group-item>
						</b-list-group>
                    </b-card>
                </div>
            </b-overlay>
        </div>
    </div>
</template>
<script>

    import store from "@/store";
    export default {
        data()
        {
            return {
                loading: false,
                rootImagePath: "",
                shops: []
            };
        },

        beforeMount()
        {
            store.selectedShop = null;
            store.selectedProduct = null;

            this.initShops();
        },

        methods: {

            initShops()
            {
                this.loading = true;

                axios({ method: "post", url: "/api/CustomerShop/GetShops" })
                    .then(response =>
                    {
                        this.shops = response.data.shops;
                        this.rootImagePath = response.data.rootImagePath;
                        this.loading = false;
                    })
                    .catch(error => { });
            },

            initCreateProduct(shop)
            {
                store.selectedShop = shop;
                this.$router.push({ name: 'club', params: { action: 'shopCreateProduct' } });
            }
        }
    };
</script>
<style scoped>
    .shop .img {
        background-position: center center;
        background-size: cover;
        background-repeat: no-repeat;
        width: 100%;
        height: 300px;
    }

    .shop a {
        color: #007bff;
        text-decoration: none;
        cursor: pointer;
    }

        .shop a:hover {
            font-weight:bold;
            color: #007bff;
        }
</style>
